import React from 'react';
import styles from './BackgroundImage.module.css';
import {
  constants
} from '@match/react-component-library';

export interface BackgroundImageProps {
  dark: boolean;
}

const getBackgroundImage = (dark: boolean)  => {
  if (dark) {
    return `url(${process.env.PUBLIC_URL}/bkg@2x.png)`;  
  } else {
    return `none`;
  }
}

const getBackgroundColor = (dark: boolean)  => {
  if (dark) {
    return constants.SEMANTIC_COLOR_NAME.PRIMARY1;  
  } else {
    return constants.SEMANTIC_COLOR_NAME.LIGHT;
  }
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({
  dark,
  children
}) => {
  return (
    <div style={{ backgroundImage: getBackgroundImage(dark), backgroundColor: getBackgroundColor(dark)}} className={styles.background}>
      {children}
    </div>
  );
};

export default BackgroundImage;